import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000/v7",
  headers: {
    "Content-Type": "application/json"
  }
});

export const responseInterceptors = ({ resolve, reject }) => {
  if (typeof resolve === "function" || typeof reject === "function") {
    instance.interceptors.response.use(resolve, reject);
  }
};

export default instance;
